import * as React from 'react';
import { UNSAFE_NavigationContext } from 'react-router-dom';
import type { History } from 'history';

export function useBlocker(blocker: (nextLocation: string) => boolean, when = true): void {
  const navigator = React.useContext(UNSAFE_NavigationContext)
    .navigator as History;

  React.useEffect(() => {
    const push = navigator.push;
    if (!when) return;

    navigator.push = (...args: Parameters<typeof push>) => {
      blocker(args[0]['pathname']);
    };
    return () => {
      navigator.push = push;
    };
  }, [navigator, blocker, when]);
}
